var _g, _g2, _path, _circle, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPlacemarkRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 62,
    viewBox: "0 0 40 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6473_71927)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 56,
    rx: 10,
    ry: 1.5,
    fill: "black",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6473_71927)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1004,
    cy: 55.8,
    rx: 3.7,
    ry: 0.799999,
    fill: "#333333"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95833 0 0 9.94738 0 19C0 35.567 13.3333 48.1119 18.2292 54.4432C18.2292 54.4432 19.6547 56 20 56C20.3453 56 21.7708 54.4432 21.7708 54.4432C26.6667 48.1146 40 35.5763 40 19C40 9.94738 31.0417 0 20 0Z",
    fill: "#ED145B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 15,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3885 17.7028C11.1947 18.9474 11.2052 20.9405 12.412 22.172C13.6189 23.4034 15.5723 23.4141 16.792 22.196L24.3852 14.4481C25.186 13.6484 25.5039 12.4714 25.2178 11.3661C24.9317 10.2607 24.0856 9.39736 23.0023 9.10542C21.919 8.81347 20.7654 9.1379 19.9817 9.95496L12.3885 17.7028Z",
    fill: "url(#paint0_linear_6473_71927)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6194 25.5282C14.8154 26.3314 14.4961 27.5135 14.7834 28.6237C15.0707 29.7339 15.9202 30.6009 17.0079 30.8942C18.0956 31.1874 19.2537 30.8615 20.0406 30.0409L27.6659 22.2594C28.8091 21.0022 28.7741 19.0473 27.5865 17.8336C26.399 16.6199 24.4838 16.5815 23.2505 17.7467L15.6194 25.5282Z",
    fill: "url(#paint1_linear_6473_71927)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.62 16.7568C12.8969 16.7568 11.5 18.1775 11.5 19.9299C11.5 21.6824 12.8969 23.103 14.62 23.103H25.38C27.1031 23.103 28.4999 21.6824 28.4999 19.9299C28.4999 18.1775 27.1031 16.7568 25.38 16.7568L14.62 16.7568Z",
    fill: "url(#paint2_linear_6473_71927)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6473_71927",
    x: 7,
    y: 51.5,
    width: 26,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_6473_71927"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6473_71927",
    x: 15.4004,
    y: 54,
    width: 9.40039,
    height: 3.59961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_6473_71927"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6473_71927",
    x1: 18.3877,
    y1: 28.32,
    x2: 30.627,
    y2: 16.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#236EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#13A6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#05D6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6473_71927",
    x1: 21.6453,
    y1: 36.1887,
    x2: 33.933,
    y2: 24.1425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5032C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#4C44C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4175B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2FC1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#28E1A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6473_71927",
    x1: 11.5,
    y1: 23.1027,
    x2: 28.4985,
    y2: 23.1027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0096DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0BABCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#18C3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21D4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#26DEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E1A0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPlacemarkRed);
export default __webpack_public_path__ + "static/media/map-placemark-red.7662df453f0d1340282b92976d9f1d7a.svg";
export { ForwardRef as ReactComponent };